export const FACEBOOK_APP_ID: { [siteId: string]: string } = {
    'mojasvadba.sk': '373107819549117',
    'mojasvadba.zoznam.sk': '373107819549117',
    'zoznam.sk': '373107819549117',
    'beremese.cz': '451121888432027',
    'zahrada.sk': '175139883028113',
    'modrastrecha.cz': '943123099075437',
    'modrastrecha.sk': '623234401145790',
};
